// Dati numerici della sezione "Chi siamo" (usati sia dal componente React sia dal pre-render statico).
// `value` è il valore finale mostrato anche senza JavaScript; `countTo` attiva l'animazione del contatore.
export const STATS = [
    { value: "100+", label: "Attrezzature e impianti installati", countTo: 100, suffix: "+" },
    { value: "48–72h", label: "Tempo medio assistenza", accent: true },
    { value: "6", label: "Divisioni specializzate", countTo: 6 },
    { value: "100%", label: "Ricambi originali" },
];
